let authData = {
  token: null,
  user: null,
};

export const setAuthData = (token, user) => {
  authData.token = token;
  authData.user = user;
};

export const getToken = () => authData.token;
export const getUser = () => authData.user;
export const clearAuth = () => {
  authData.token = null;
  authData.user = null;
};
